/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { createContext, useContext, useState } from 'react';

const MFAContext = createContext({});

export const MFAContextProvider = ({ children }) => {
  const [attempts, setAttempts] = useState(1);
  const [credentials, setCredentials] = useState({
    login: sessionStorage.getItem('@UltragazEmpresarial:X-Mfa-Login') || '',
    password: '',
    token: localStorage.getItem('@UltragazEmpresarial:X-Mfa-Hash') || '',
  });
  const [userId, setUserId] = useState(null);

  return (
    <MFAContext.Provider
      value={{
        credentials,
        setCredentials,
        setAttempts,
        attempts,
        userId,
        setUserId,
      }}
    >
      {children}
    </MFAContext.Provider>
  );
};

export const useMFAContext = () => useContext(MFAContext);
